import {
  GOOGLE_CLICK_ID_PARAMS,
  UTM_QUERY_PARAMS,
} from 'shared/presentation/constants';

import getGoogleClickIdentifier from './getGoogleClickIdentifier';

type TGoogleClickIdParam = (typeof GOOGLE_CLICK_ID_PARAMS)[number];
type TUtmParam = Exclude<
  (typeof UTM_QUERY_PARAMS)[number],
  TGoogleClickIdParam
>;

const FORMAT_UTM_PARAM: Record<TUtmParam, string> = {
  utm_campaign: 'campaign',
  utm_term: 'term',
  utm_source: 'source',
  utm_medium: 'medium',
  utm_content: 'content',
  ltk_gcm: 'ltk_gcm',
  ltk_gag: 'ltk_gag',
  ltk_gac: 'ltk_gac',
  ltk_gne: 'ltk_gne',
  fbclid: 'facebookId',
};

export default function getUtmsFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const utms: any = {};

  UTM_QUERY_PARAMS.forEach(param => {
    if ((GOOGLE_CLICK_ID_PARAMS as readonly string[]).includes(param)) return;

    const value = params.get(param);
    if (value) utms[FORMAT_UTM_PARAM[param as TUtmParam]] = value;
  });

  const { googleId, googleIdType } = getGoogleClickIdentifier(params.entries());
  if (googleId) {
    utms.googleId = googleId;
    utms.googleIdType = googleIdType;
  }

  return utms;
}
